export const S3_BUCKET_URL = "https://erpforce-dev.s3.eu-west-1.amazonaws.com/"